import React, { Component, useState, useMemo, useEffect } from 'react';
import { RelevantIcon, reversibleHash, setCookie } from '../oro-module/commonFunctions';
import { MdOpenInNew } from "react-icons/md";
import { fetchData } from '../common/networkRequests';
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import { handlePageChange } from '../oro-module/ajaxdata';
import moment from "moment";
import requiredFields from '../oro-module/requiredFields';

const FollowupListRecord = ({ main, sub, current, showvalues, dformat, islast = false, identif, clickable }) => {


  let { color, size, weight, desc, value, url, payload, message } = main;

  if (value == 'icon-tick') { color = "#6de26d" } else if (value == 'icon-cross') { color = "red" } else { color = color ? color : "black" }

  const KPIValue = ({ value, style }) => {
    if (String(value).indexOf('icon-') != -1) {
      return <RelevantIcon icon={value.split('-')[1]} />;
    }
    else {
      return value;
    }
  }

  let sendData;
  let identi = Math.round(Math.random() * 10000000000);
  let gotourl = `/${url}`;
  if (payload) {
    gotourl = `/${url}/${identi}`;
    sendData = {};
    for (var key in payload) {
      if (payload[key].type == 'fixed') {
        sendData[key] = payload[key].value;
      }
    }
  }





  const handleLink = ({ url, identi, sendData }) => {
    let { username } = current.props.parentProps.parentState.profile;
    let newurl = url;
    if (['apex', 'oro'].indexOf(username) == -1) {
      if (url == '/rp101m') {
        url = '/rp101o';
      } else if (url == '/report_acceptances') {
        url = '/report_verifications';
      } else if (url == '/apexpendency') {
        url = '/bankapexpendency';
      }
      else if (url == '/pacs_financial_position_bank') {
        url = '/pacs_financial_position';
      }
      else if (url == '/pacs_ots_bank') {
        url = '/pacs_ots_position';
      }
    }

    let masters = ['assign_auditors', 'users', "roles", "assign_talathis", "feedbacks", "calamity_fund_uploads", "error_logs"];

    if (url.substr(1, 2) == 'rp' || masters.indexOf(url.replace('/', '')) != -1) {
      handlePageChange({ item: { fastpath: url.replace("/", ""), label: "" }, current });
    } else {
      url = 'enc-' + encodeURIComponent(reversibleHash(url));
      // window.open(url, "test", 'directories=no,titlebar=no,toolbar=no,');
      window.open(url, "_blank");
    }
  }

  const setMessage = (message) => {
    // current.props.liftGlobalState
  }

  const removeMessage = (message) => { }

  let valueStyle = {}
  if ((color == 'red' || color == 'orange') && 'icon-'.indexOf(value) == -1) {
    valueStyle['paddingLeft'] = 5;
    valueStyle['paddingRight'] = 5;
    valueStyle['paddingTop'] = 2;
    valueStyle['paddingBottom'] = 2;

    valueStyle['backgroundColor'] = color;
    valueStyle['color'] = 'white';
    valueStyle['borderRadius'] = 5;


  } else {
    valueStyle['color'] = color;
  }
  if (!desc) {
    desc = "";
  }

  let showlabel = desc.substr(0, 50) + (desc.length > 50 ? '...' : '');
  let onhover = desc.length > 50 ? desc : "";


  return (
    <div className="row"
      // style={{ marginLeft: -5, marginRight: -10, backgroundColor: main.color ? main.color : "" }}
      style={{ marginTop: 4, marginBottom: 3, paddingLeft: 5 }}
    >
      {!url &&
        <div className="col-sm-7 not-url-kpi sub-title" style={{ fontSize: 14 }}>{showlabel}</div>
      }

      {url &&
        <div className={`${showvalues ? 'col-sm-7' : 'col-sm-12'} url-kpi sub-title`}><span className={`${clickable ? 'hand kpi-link' : ''} `} onClick={() => clickable ? handleLink({ url: gotourl, sendData, identi }) : false}>{showlabel}
          {/* <MdOpenInNew />  */}
        </span></div>
      }

      {showvalues &&
        <div className="col-sm-5 action right kpivalue"
          // onMouseEnter={() => setMessage(message)} onMouseLeave={() => removeMessage(message)} 
          style={{ fontSize: size ? size : 16 }}>
          <span style={valueStyle}> <KPIValue value={value} /></span>
        </div>
      }
      {!islast &&
        <div className="col-sm-12"><hr style={{ margin: 0 }}></hr></div>
      }
    </div>
  );
}


const KPIList = (props) => {
  let { values, showvalues, ddType, dformat, clickable, emptymsg } = props.component;
  let { selectedTourBranch } = props.parentState.LocalVars;
  let [dashboarddata, setdashboarddata] = useState([]);
  let [loading, setloading] = useState(false);

  if (!emptymsg) { emptymsg = "No Data" }

  const setDashData = (alldata) => {
    // alldata.results
    setdashboarddata(alldata.results);
    setloading(false);
  }

  const getLatestData = (selectedTourBranch) => {
    let method = 'post';
    let pd = { gui: "dashboard" };
    if (selectedTourBranch) {
      pd['branch_uid'] = selectedTourBranch.value;
    }
    let saveThis = { dataType: "search", pageData: pd, currentPage: ddType };
    if (ddType) {
      setloading(true);
      fetchData({ url: 'cbsurl', postData: saveThis, method, current: { props }, cbf: setDashData });
    }
  }

  useMemo(() => getLatestData(selectedTourBranch), [selectedTourBranch]);
  let hasclickable = false;
  return (
    <div
      className={`form-group nopadding kpilist-container ${props.component.widths.parent}`}
    >

      {loading &&
        <Skeleton count={5} />
      }

      {values && !loading &&
        values.map(({ main, sub }, idx) => {
          return (
            <div key={idx} className="fl-rec">
              {/* <div className="col-sm-12"> */}
              <FollowupListRecord main={main} islast={values.length - 1 == idx} showvalues={showvalues} sub={sub} current={{ props }} dformat={dformat} clickable={clickable} />
              {/* </div> */}
            </div>
          )
        })
      }

      {!values && !loading &&
        dashboarddata.map((ddata, idx) => {
          let vals = {};
          let cc = true;
          if (dformat.format == 'progress') {
            vals['desc'] = ddata[dformat.label];
            if (dformat.displayType == 'tick') {
              vals['value'] = ddata[dformat.value] ? 'icon-tick' : 'icon-cross';
            } else {
              vals['value'] = ddata[dformat.value];
            }
            vals['url'] = (dformat.fastpath && dformat.fastpath.indexOf('#') != -1) ? dformat.fastpath.replace("#", "") : ddata[dformat.fastpath];

            let deadline = `Deadline ${moment(ddata.deadline).format("DD-MM-YYYY")}`;
            let comp = ddata.completed ? ddata.completed : 0;
            let tot = ddata.total;


            if (dformat.completeBy) {
              // if acknowledged, green tick
              // if total >0, count/total
              // if total =0, red cross 
              if (ddata.acknowledge && comp == tot) {
                vals['value'] = 'icon-tick';
                cc = false;
              } else if (ddata.total == 0) {
                vals['value'] = 'icon-cross';
                // vals['value'] = deadline;
                // vals['color'] = "red"
              } else {

                vals['value'] = comp + '/' + tot + ' : ' + deadline;
                // vals['value'] = comp + '/' + tot + ` : Deadline ${moment(ddata.deadline).fromNow()}`;
                vals['size'] = 14;
                if (comp == tot) {
                  vals['value'] = "FINAL SUBMISSION PENDING"
                }
                vals['color'] = 'orange';
              }
            }
          } else if (dformat.format == 'aduitorchecklist') {
            vals['desc'] = ddata[dformat.label];
            if (ddata.submitted == 0) {
              vals['value'] = 'icon-cross';
              vals['url'] = ddata['fastpath'] + "/" + ddata['uid'] + "/" + ddata['label_uid']
            } else if (ddata.success == ddata.total) {
              vals['value'] = 'icon-tick';
              vals['url'] = "#";
            } else {
              vals['value'] = ddata.success + "/" + ddata.total;
              vals['color'] = 'orange';
              vals['url'] = ddata['fastpath'] + "/" + ddata['uid'] + "/" + ddata['label_uid']
            }
          }
          else if (dformat.format == 'recompliance') {
            vals['desc'] = ddata[dformat.label];
            vals['value'] = 'icon-cross';
            vals['url'] = ddata['fastpath'] + "/" + ddata['uid']
          }
          else if (dformat.format == 'uploaded_file_status') {
            vals['desc'] = ddata[dformat.label];

            if (ddata[dformat.value] != 0) {
              vals['value'] = ddata[dformat.value] + "/" + ddata["total_uploads"]
            } else if (ddata.acceptance_id) {
              vals['value'] = "icon-cross";
              // vals['url'] = "/calamity_fund_uploads/" + dformat.uid;
            } else {
              vals['value'] = "icon-tick";
            }

            vals['color'] = 'red';
          }
          else if (dformat.format == 'uploaded_file_status_taluka') {
            vals['desc'] = ddata["talathi_name"].toUpperCase() + " - " + ddata["village_display"];
            vals['value'] = ddata[dformat.value] != 0 ? ddata[dformat.value] + "/" + ddata["total_uploads"] : "icon-tick";
            vals['color'] = 'red';
            if (ddata[dformat.value] == 0) {
              vals['url'] = dformat.url + "/" + ddata["uid"];
            }
          }
          else if (dformat.format == 'failed_uploads') {
            vals['desc'] = ddata[dformat.label];
            vals['value'] = ddata[dformat.value];
            vals['url'] = ddata['fastpath'] + "/" + ddata['uid']
            vals['color'] = 'orange'
          }

          let identif = ddata.uid;

          if (dformat.hasvar3) {
            identif += "/" + ddata[dformat.hasvar3];
          }

          return (
            <div key={idx} className="fl-rec">
              <FollowupListRecord main={vals} identif={identif} islast={dashboarddata.length - 1 == idx} showvalues={true} current={{ props }} dformat={dformat} clickable={cc} />
            </div>
          )
        })
      }

      {!values && !loading && dashboarddata.length == 0 &&
        <div className="empty-message"><RelevantIcon icon="exclaim-circle" />&nbsp;{emptymsg}</div>
      }
    </div>
  )
}

export default KPIList;